import { Component, inject } from '@angular/core';
import { MagicSearchService } from '../../../creators/service/magic-search/magic-search.service';
import { CreatorCardPinkComponent } from '../creator-card-pink/creator-card-pink.component';

@Component({
  selector: 'cv2-for-you-creators',
  standalone: true,
  imports: [CreatorCardPinkComponent],
  templateUrl: './for-you-creators.component.html',
  styleUrl: './for-you-creators.component.css'
})
export class ForYouCreatorsComponent {

  /** Services */
  public magicSearchService = inject(MagicSearchService);
  /** Services - END */
}
